import { useContext } from 'react';
import Context from 'contexts/ListingType/ListingTypeContext';

export default () => {
    const { state, actions } = useContext(Context);
    return [state, actions];
};
